import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Users, Shield } from "lucide-react";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4 relative">
      {/* Admin Button rechts oben */}
      <Button
        onClick={() => navigate("/admin")}
        className="absolute top-4 right-4 bg-gray-600 hover:bg-gray-700 text-white rounded-full px-6 py-2 flex items-center gap-2 shadow-lg"
        data-testid="admin-login-button"
      >
        <Shield className="w-4 h-4" />
        Admin
      </Button>

      {/* Mitarbeiter Login zentral */}
      <div className="max-w-md w-full">
        <div className="text-center mb-12">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-4 text-gray-800" style={{ fontFamily: 'Work Sans, sans-serif' }}>
            Zeiterfassung
          </h1>
          <p className="text-lg text-gray-600" style={{ fontFamily: 'Inter, sans-serif' }}>
            Melden Sie sich mit Ihrem PIN-Code an
          </p>
        </div>

        <div 
          className="bg-white rounded-3xl p-12 shadow-2xl hover:shadow-3xl transition-all duration-300 cursor-pointer border-2 border-transparent hover:border-blue-300"
          onClick={() => navigate("/employee")}
          data-testid="employee-login-card"
        >
          <div className="flex flex-col items-center text-center space-y-8">
            <div className="w-32 h-32 bg-blue-100 rounded-full flex items-center justify-center">
              <Users className="w-16 h-16 text-blue-600" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-3" style={{ fontFamily: 'Work Sans, sans-serif' }}>
                Mitarbeiter Login
              </h2>
              <p className="text-gray-600 text-lg" style={{ fontFamily: 'Inter, sans-serif' }}>
                Zeiten erfassen mit PIN-Code
              </p>
            </div>
            <Button 
              size="lg" 
              className="w-full rounded-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-8 text-xl transition-colors duration-200"
              data-testid="employee-login-button"
            >
              Jetzt anmelden
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
